import { format, parseISO } from 'date-fns';
import { formatISODateInTimezone } from 'utils/shared/time/formatEventDateTime';
import { SortByEnum, TimeEnum } from './enums';
import { ClinicType } from './props';
import { resolveVenueTimeZone } from 'utils/shared/time/venueDayFilters';

export const sortOptions = [
  { label: 'Coach Rating', value: SortByEnum.CoachRating },
  { label: 'Price Low-High', value: SortByEnum.PriceLowHigh },
  { label: 'Price High-Low', value: SortByEnum.PriceHighLow },
  { label: 'Nearest Time', value: SortByEnum.NearestTime },
  { label: 'Players Going', value: SortByEnum.PlayersGoing },
  { label: 'Distance', value: SortByEnum.Distance },
];

export const timeOptions = [
  {
    label: 'All',
    value: TimeEnum.All,
  },
  {
    label: 'Morning',
    value: TimeEnum.Morning,
  },
  {
    label: 'Afternoon',
    value: TimeEnum.Afternoon,
  },
  {
    label: 'Evening',
    value: TimeEnum.Evening,
  },
];

/**
 * Groups clinic objects by their start date
 * @param clinics Array of clinic objects
 * @returns An object with dates as keys and arrays of clinics as values
 */
export const groupClinicsByDate = (clinics: ClinicType[]) => {
  const groupedClinics: Record<string, ClinicType[]> = {};
  const processedDates = new Set<string>();

  // Process each clinic without re-sorting
  clinics.forEach((clinic) => {
    const dateKey = formatISODateInTimezone(
      clinic.startDateTime,
      resolveVenueTimeZone(clinic),
    );

    if (!groupedClinics[dateKey]) {
      processedDates.add(dateKey);
      groupedClinics[dateKey] = [];
    }

    groupedClinics[dateKey].push(clinic);
  });

  // Sort the dates chronologically
  const sortedDates = Array.from(processedDates).sort();

  return {
    groupedClinics,
    dates: sortedDates,
  };
};

/**
 * Gets a formatted date string for display
 * @param dateString Date string in ISO format
 */
export const getFormattedDateHeader = (dateString: string) => {
  const date = parseISO(dateString);
  return {
    formattedDate: format(date, 'MMMM d'),
    formattedYear: format(date, 'yyyy'),
  };
};
